import type { ReactNode } from 'react';

import type { AspectRatio, BackgroundColor } from '../../../constants';
import type { BaseComponentProps, ImageSources } from '../../../types';

export type CardStackCardAspectRatio = Extract<AspectRatio, '16:9' | '3:2' | '1:1'>;

export interface CardStackCardProps extends BaseComponentProps {
  aspectRatio?: CardStackCardAspectRatio;
  body?: ReactNode;
  imgAltText?: string;
  imgSrcs?: ImageSources;
  media: ReactNode;
  mobileVideoSource?: string;
  posterSource?: string;
  theme?: BackgroundColor;
  title: string;
  url?: string;
  videoSource?: string;
}
